
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/landing-pages-that-generate-leads",
      function () {
        return require("private-next-pages/landing-pages-that-generate-leads/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/landing-pages-that-generate-leads"])
      });
    }
  